import React from 'react';
import { Outlet, NavLink, Link, useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { LayoutDashboard, FileText, Newspaper, Globe, Map, Users, ShieldCheck, Inbox, LogOut, Settings } from 'lucide-react';
import Logo from '../../components/Logo';

const NAV = [
  { to: '/admin', label: 'Dashboard', Icon: LayoutDashboard, end: true, perm: 'cms.read' },
  { to: '/admin/pages', label: 'Pages (CMS)', Icon: FileText, perm: 'pages.read' },
  { to: '/admin/articles', label: 'Articles (Blog)', Icon: Newspaper, perm: 'articles.read' },
  { to: '/admin/languages', label: 'Languages', Icon: Globe, perm: 'languages.read' },
  { to: '/admin/countries', label: 'Countries', Icon: Map, perm: 'countries.read' },
  { to: '/admin/contacts', label: 'Contacts', Icon: Inbox, perm: 'contacts.read' },
  { to: '/admin/users', label: 'Users', Icon: Users, perm: 'users.read' },
  { to: '/admin/roles', label: 'Roles & Permissions', Icon: ShieldCheck, perm: 'roles.read' },
];

export default function AdminLayout() {
  const { user, loading, logout, can } = useAuth();
  const nav = useNavigate();
  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return (
    <div className="min-h-screen admin-bg flex">
      <aside className="w-[260px] bg-[#0F0F10] text-white flex flex-col p-5 sticky top-0 h-screen">
        <Link to="/admin" className="px-2"><Logo variant="light" /></Link>
        <nav className="mt-8 flex-1 space-y-1">
          {NAV.filter(n => can(n.perm) || can('all')).map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm transition-colors ${isActive ? 'bg-[#F4E94B] text-[#0F0F10] font-semibold' : 'text-white/80 hover:bg-white/10'}`}>
              <n.Icon size={16} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-white/10 pt-4">
          <div className="px-3 py-2">
            <p className="text-sm font-semibold">{user.name}</p>
            <p className="text-xs text-white/55">{user.role_name}</p>
          </div>
          <button onClick={() => { logout(); nav('/admin/login'); }} className="mt-2 w-full inline-flex items-center gap-2 px-3 py-2.5 rounded-xl text-sm text-white/80 hover:bg-white/10"><LogOut size={16} /> Sign out</button>
        </div>
      </aside>
      <main className="flex-1 p-8">
        <Outlet />
      </main>
    </div>
  );
}

export function AdminPageHeader({ title, description, actions }) {
  return (
    <div className="flex items-end justify-between gap-4 mb-8">
      <div>
        <h1 className="heading-display text-3xl lg:text-4xl">{title}</h1>
        {description && <p className="mt-2 text-stone-600">{description}</p>}
      </div>
      {actions}
    </div>
  );
}
